import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter } from '../../../global/commonStyle';

interface Props {
  color?: string;
  isCreateTask?: boolean;
  isTaskDetail?: boolean;
  isActive?: boolean;
}

const IconDiv = styled.div<Props>`
  ${AlignCenter}
  flex-wrap: wrap;
  gap: var(--space-10);
  padding: var(--space-6) var(--space-12);
  box-shadow: ${({ isCreateTask }) => (isCreateTask ? 'var(--border)' : 'none')};
  border-radius: var(--border-radius-8);
  &:hover {
    box-shadow: var(--border);
    background-color: var(--background-primary);
    svg path {
      fill: var(--text-primary);
    }
  }
  ${(props: Props) =>
    props.isActive &&
    css`
      box-shadow: var(--border);
      background-color: var(--background-primary);
      svg path {
        fill: var(--text-primary);
      }
    `}
  ${(props: Props) =>
    props.isTaskDetail &&
    css`
      max-width: 185px;
      flex-wrap: nowrap;
      &.multiline {
        align-items: flex-start;
        .label-icon {
          padding-top: var(--space-2);
        }
      }
      ${mobile_xl(css`
        max-width: 250px;
      `)}
    `}
  ${(props: Props) =>
    props.isCreateTask &&
    css`
      padding: var(--space-3) var(--space-8);
      gap: var(--space-6);
      flex-wrap: nowrap;
      &.multiline {
        align-items: flex-start;
        .label-icon {
          padding-top: var(--space-2);
        }
      }
      &:hover {
        background-color: var(--neutral-secondary);
      }
    `}
    ${(props: Props) =>
    props.isActive &&
    props.isCreateTask &&
    css`
      background-color: var(--neutral-secondary);
    `}
`;
const ColorIcon = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
`;
const LabelIcon = styled.div<Props>`
  width: 8px;
  height: 8px;
  border-radius: var(--border-radius-full);
  ${(props: Props) =>
    props.color &&
    css`
      background-color: ${props.color};
    `}
`;
const RightText = styled.div<Props>`
  ${Typography.body_md_medium}
  color: var(--text-primary);
  margin: var(--space-0);
  width: 100%;
  white-space: nowrap;

  p {
    ${Typography.body_md_medium}
    margin: var(--space-0);
  }
  ${(props: Props) =>
    props.isCreateTask &&
    css`
      p {
        color: var(--text-secondary);
      }
      display: none;
    `}
`;

const IconMainDiv = styled.div`
  width: 12px;
  height: 12px;
  ${AlignCenter}
`;

const SelectedLabelDiv = styled.div`
  ${AlignCenter}
  flex-wrap: wrap;
  gap: var(--space-6);
`;
const Icon = styled.div`
  width: 16px;
  height: 16px;
`;
export { LabelIcon, IconDiv, ColorIcon, RightText, IconMainDiv, SelectedLabelDiv, Icon };
